var clientSlider = document.querySelector(".client-sayslide");
if (clientSlider) {
  new Splide(clientSlider, {
    loop: 1,
    perPage: 1,
    perMove: 1,
    type: "loop",
    focus: "center",
    autoplay: true,
    gap: "1.5rem",
    pagination: false,
    arrows: false,
    breakpoints: {
      640: {
        perPage: 1,
        gap: "1rem",
      },
      992: {
        perPage: 1,
        gap: "1rem",
      },
    },
  }).mount();
}

document.addEventListener("DOMContentLoaded", function () {
  const allQuestions = document.querySelectorAll(".faq-question");

  allQuestions.forEach((question) => {
    question.addEventListener("click", () => {
      const faqItem = question.closest(".faq-item");
      const side = faqItem.getAttribute("data-faq-side");
      const isOpen =
        faqItem.querySelector(".faq-answer").style.display === "block";

      // Close only questions in the same column
      document
        .querySelectorAll(`.faq-item[data-faq-side="${side}"]`)
        .forEach((item) => {
          item.querySelector(".faq-answer").style.display = "none";
          item.querySelector(".faq-icon").textContent = "+";
        });

      // Toggle current
      if (!isOpen) {
        faqItem.querySelector(".faq-answer").style.display = "block";
        faqItem.querySelector(".faq-icon").textContent = "–";
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const faqQuestions = document.querySelectorAll(".custom-faq-question");

  faqQuestions.forEach((question) => {
    question.addEventListener("click", () => {
      const answer = question.nextElementSibling;
      const icon = question.querySelector(".custom-faq-icon");
      const isOpen = answer.classList.contains("open");

      // Close all
      document.querySelectorAll(".custom-faq-answer").forEach((a) => {
        a.style.maxHeight = null;
        a.classList.remove("open");
      });
      document.querySelectorAll(".custom-faq-question").forEach((q) => {
        q.classList.remove("active");
        q.querySelector(".custom-faq-icon").textContent = "+"; // Reset icons
      });

      // Toggle current
      if (!isOpen) {
        answer.classList.add("open");
        question.classList.add("active");
        answer.style.maxHeight = answer.scrollHeight + "px";
        icon.textContent = "–"; // Change to minus
      }
    });
  });
});

function formatDate(dateStr) {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${month} - ${day} - ${year.slice(2)}`;
}

function combineMinorData() {
  const firstNames = document.querySelectorAll(
    'input[name="minor_first_name[]"]'
  );
  const lastNames = document.querySelectorAll(
    'input[name="minor_last_name[]"]'
  );
  const birthdates = document.querySelectorAll(
    'input[name="minor_birthdate[]"]'
  );

  let combinedData = "";
  for (let i = 0; i < firstNames.length; i++) {
    const formattedDate = formatDate(birthdates[i].value);
    combinedData += `Minor ${String(i + 1).padStart(2, "0")}:\n`;
    combinedData += `First Name: ${firstNames[i].value}\n`;
    combinedData += `Last Name: ${lastNames[i].value}\n`;
    combinedData += `Birthdate: ${formattedDate}\n\n`;
  }

  document.getElementById("minorDataField").value = combinedData;

  // Format adult DOB
  const adultDateInput = document.querySelector(
    'input[name="contact[adult_birthdate]"]'
  );
  if (adultDateInput && adultDateInput.value) {
    adultDateInput.value = formatDate(adultDateInput.value);
  }
}

function addMinor() {
  const container = document.getElementById("minors-container");
  const currentMinors = container.querySelectorAll(".minor-block");
  const newIndex = currentMinors.length + 1;
  const blockId = "minor-block-" + Date.now();

  const minorHTML = `
    <div class="minor-block" id="${blockId}">
      <div class="minor-header">
        <h4>Minor ${String(newIndex).padStart(2, "0")}</h4>
        <button type="button" class="remove-minor" onclick="removeMinor('${blockId}')">✖</button>
      </div>
      <div class="form-row contact__fields">
      <div class="field"><input type="text" class="field__input" name="minor_first_name[]" placeholder="Enter first name" required>
       <label class="field__label">First Name</label></div>
      <div class="field"><input type="text" class="field__input" name="minor_last_name[]" placeholder="Enter last name" required>
       <label class="field__label">Last Name</label></div>
      </div>
      <div class="form-row">
        <div class="field"><input type="date" class="field__input" name="minor_birthdate[]" placeholder="mm - dd - yy" required>
        <label class="field__label">Birth Date</label></div>
      </div>
    </div>`;

  container.insertAdjacentHTML("beforeend", minorHTML);
}

function removeMinor(id) {
  const el = document.getElementById(id);
  if (el) el.remove();

  const minors = document.querySelectorAll("#minors-container .minor-block");
  minors.forEach((minorEl, index) => {
    const header = minorEl.querySelector("h4");
    if (header) {
      header.textContent = `Minor ${String(index + 1).padStart(2, "0")}`;
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const phoneInput = document.querySelector('input[name="contact[phone]"]');
  phoneInput?.addEventListener("input", function () {
    this.value = this.value.replace(/[^0-9]/g, "");
  });

  const form = document.getElementById("BookingForm");

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault(); // prevent early submit

      combineMinorData(); // now populate the hidden field

      setTimeout(() => {
        form.submit(); // now safely submit after hidden field update
      }, 10); // slight delay ensures field update is registered
    });
  }
});
